interface PaginationProps {
  current: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  for (let i = 1; i <= totalPages; i += 1) pages.push(i);

  return (
    <nav className="mt-10 flex items-center justify-center gap-2 flex-wrap" aria-label="分页">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, current - 1))}
        disabled={current === 1}
        className="inline-flex items-center gap-1 h-9 px-3 rounded-md border border-background-200 bg-background-50 text-xs font-label font-semibold text-foreground-700 whitespace-nowrap transition-colors cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed hover:bg-background-100"
      >
        <i className="ri-arrow-left-s-line w-4 h-4 flex items-center justify-center" />
        上一页
      </button>

      <div className="flex items-center gap-1.5">
        {pages.map((page) => (
          <button
            key={page}
            type="button"
            onClick={() => onChange(page)}
            aria-current={page === current ? "page" : undefined}
            className={`w-9 h-9 rounded-md text-xs font-label font-semibold transition-colors cursor-pointer ${
              page === current
                ? "bg-primary-600 text-background-50"
                : "bg-background-50 border border-background-200 text-foreground-700 hover:bg-background-100"
            }`}
          >
            {page}
          </button>
        ))}
      </div>

      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, current + 1))}
        disabled={current === totalPages}
        className="inline-flex items-center gap-1 h-9 px-3 rounded-md border border-background-200 bg-background-50 text-xs font-label font-semibold text-foreground-700 whitespace-nowrap transition-colors cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed hover:bg-background-100"
      >
        下一页
        <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center" />
      </button>
    </nav>
  );
}